
import {IonPage, IonContent, IonToolbar, IonButtons, IonBackButton} from '@ionic/vue'
import {defineComponent} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useI18n} from "vue-i18n";
import {useStore} from "@/store/store";
import {createEmptyTool, Tool, ToolUtils} from "@/store/state";
import HomeButton from "@/components/HomeButton.vue";
import MarkdownIt from "markdown-it"
import {TaskState, Task, Review} from "@/store/state";


export default defineComponent({
  components: {HomeButton, IonPage, IonContent, IonToolbar, IonButtons, IonBackButton},
  name: "Stats",

  methods: {
    completeTasks(){
      return this.store.state.tasks.filter((t: Task) => t.state === TaskState.Done ).length
    },
    incompleteTasks(){
      return this.store.state.tasks.filter((t: Task) => t.state != TaskState.Done ).length
    },
    reviewedTasks(){
      return this.store.state.reviews.map(r => r.tasks.length).reduce((a,b)=>a+b,0)
    }
  },
  setup(props) {

    const router = useRouter();
    const {t, locale} = useI18n()
    const store = useStore();

    //scheiss workaround, bis das routing richtig funktioniert
    const route = useRoute();
    return {
      t,
      locale,
      router,
      store}
  }
});
